import { Pipe, PipeTransform } from '@angular/core';

/**
 * @whatItDoes
 * @howToUse `value | wlRegexReplace:regexPattern[:replaceWith]`
 * @description
 *
 * Where:
 * - `value` a string
 * - `regexPattern` a regular expression pattern suitable to pass to the regex constructor
 * - `regexOptions` a regex options like 'i' or 'ig'
 * - `replaceWith` the text that will replace any substring that matches the regexPattern
 *
 * In javascript, only the components specified will be respected (not the ordering,
 * punctuations, ...) and details of the formatting will be dependent on the locale.
 *
 * ### Examples
 *
 * Assuming `someString` is 'test test test'
 *
 * ```
 *     {{ someString | wlRegexReplace:'/[\\W]+/g':'-' }}               // test-test-test  (note the double backslash)
 * ```
 */
@Pipe({ name: 'wlRegexReplace', pure: true, standalone: true })
export class WlRegexReplacePipe implements PipeTransform {
  transform(value: string, regexPattern: string, regexOptions: string, replaceWith: string): string {
    if (value == null) return '';
    if (regexOptions == null) regexOptions = '';
    if (replaceWith == null) replaceWith = '';

    let reg = new RegExp(regexPattern, regexOptions);

    return value.replace(reg, replaceWith);
  }
}
